import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

// The QuickFilters row contributes its own height (32) plus the s400 gap (12)
// the NavBar inserts above it when the center content is wrapped onto its own row.
const HEADER_HEIGHT_FILTERS_MOBILE = 44
const HEADER_HEIGHT_DEFAULT = 172
const HEADER_HEIGHT_EMBEDDED = 130

/**
 * Get the height of the search mobile header spacer.
 * Returns different heights based on the brand's custom header.
 */
export const useMobileSearchHeaderHeight = (
  withMarginReduction: boolean,
  isEmbedded?: boolean
) => {
  const {shell} = useBrandCapabilities()

  if (isEmbedded) return HEADER_HEIGHT_EMBEDDED

  if (shell.mobileSearchHeaderHeight !== null) {
    return shell.mobileSearchHeaderHeight
  }

  return withMarginReduction
    ? HEADER_HEIGHT_DEFAULT - HEADER_HEIGHT_FILTERS_MOBILE
    : HEADER_HEIGHT_DEFAULT
}
